import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/** Vrai s'il existe au moins un projet publié : conditionne l'affichage de l'onglet « Projets ». */
export function useHasProjets(): boolean {
  const { data } = useQuery({
    queryKey: ["projets-count"],
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { count, error } = await supabase
        .from("projets")
        .select("id", { count: "exact", head: true })
        .eq("is_published", true);
      if (error) throw error;
      return count ?? 0;
    },
  });
  return (data ?? 0) > 0;
}
